import React from 'react';
import { Button, Checkbox, Divider, Radio } from 'antd';
import { DatabaseFilled, DeleteOutlined, GlobalOutlined, MessageFilled, PhoneFilled } from '@ant-design/icons';
import { CardBadge } from '../CardBadge';
import classNames from 'classnames';
import { IPackage } from '../../../../interfaces';
import { UnitTypeValues } from '../../../../middleware';
import { showDataWithUnit, showOriginalUnitByType } from '../../../../instruments';
import { ITrField, tF, tP } from '../../../../translate';
import TariffsStyles from '../../m_styles.less';

const PackageStats = ({ Icon, title, value }: { Icon: React.FC; title: ITrField; value?: string }) => {
    const rawValue = value?.split(' ') || ['0'];

    if (rawValue[0] === '0') {
        return null;
    }

    return (
        <div className={TariffsStyles.packageStats}>
            <div>
                <Icon />
            </div>
            <div className={TariffsStyles.packageStatsContent}>
                <span>{tF(title)}</span>
                <span>{value}</span>
            </div>
        </div>
    );
};

type IPackageCard = {
    id: string;
    isLocal: boolean;
    isSelected: boolean;
    onDelete?: (id: number) => void;
    onToggleSelect?: (id: number) => void;
    packageInfo: IPackage;
    showEditOption?: boolean;
};

export const PackageCard = ({
    id,
    isLocal,
    isSelected,
    onDelete,
    onToggleSelect,
    packageInfo,
    showEditOption = false,
}: IPackageCard) => {
    const { name, dataVolume, dataVolumeUnit, smsVolume, voiceVolume, operators, networks } = packageInfo;
    const badgeName = tF(isLocal ? 'Local' : 'Roaming');
    return (
        <div
            className={classNames(TariffsStyles.packageCard, {
                [TariffsStyles.selected]: isSelected,
            })}
            onClick={onToggleSelect ? () => onToggleSelect(+id) : undefined}
        >
            <div className={TariffsStyles.packageCardHeader}>
                <h4 className={TariffsStyles.packageCardTitle}>{name}</h4>
                <div className={TariffsStyles.packageCardBadgeContainer}>
                    <CardBadge name={badgeName} />
                    {showEditOption && !isLocal && (
                        <Button
                            className={TariffsStyles.packageCardDeleteButton}
                            size="small"
                            icon={<DeleteOutlined className={TariffsStyles.deleteButtonIcon} />}
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete?.(+id);
                            }}
                        />
                    )}
                    {!showEditOption && (
                        <div>
                            {badgeName === 'Local' ? <Radio checked={isSelected} /> : <Checkbox checked={isSelected} />}
                        </div>
                    )}
                </div>
            </div>
            <div className={TariffsStyles.packageCardStatsContainer}>
                <PackageStats
                    Icon={DatabaseFilled}
                    title={'Data'}
                    value={showDataWithUnit(dataVolume, dataVolumeUnit)}
                />
                <PackageStats
                    Icon={PhoneFilled}
                    title={'Voice'}
                    value={showOriginalUnitByType(`${voiceVolume}`, UnitTypeValues.VOICE)}
                />
                <PackageStats
                    Icon={MessageFilled}
                    title={'SMS'}
                    value={showOriginalUnitByType(`${smsVolume}`, UnitTypeValues.SMS)}
                />
            </div>
            <Divider className={TariffsStyles.tariffItemPackageViewDivider} />
            <div>
                <GlobalOutlined /> {tF('Operators')}:
                <div className={TariffsStyles.tariffItemPackageViewSmallCard}>
                    {operators?.map((value) => {
                        return (
                            <span key={value?.id} className={TariffsStyles.tariffItemPackageViewSmallCardItem}>
                                {value?.name}
                            </span>
                        );
                    })}
                </div>
                <GlobalOutlined /> {tP('Countries')}:
                <div className={TariffsStyles.tariffItemPackageViewSmallCard}>
                    {networks?.map((value) => {
                        return (
                            <span key={value.id} className={TariffsStyles.tariffItemPackageViewSmallCardItem}>
                                {value?.country?.name}
                            </span>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
